import postTypes from './postTypes';

const getPageIndexStatus = (postType, postData) => {
  const isPage = postType === postTypes.PAGE;
  const isTemplate = postType === postTypes.TEMPLATE;
  const isArticle = postType === postTypes.ARTICLE;
  const isBlog = postType === postTypes.POST;

  switch (true) {
    case isBlog:
      return postData?.postBy?.indexPage;
    case isPage:
      return postData?.pageBy?.indexPage;
    case isTemplate:
      return postData?.templateBy?.indexPage;
    case isArticle:
      return postData?.articleBy?.indexPage;
    default:
      return null;
  }
};

export default getPageIndexStatus;
